import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Flower, Dog, CloudSun, Leaf, Acorn, Drop, Mountains, ArrowUpRight } from "@phosphor-icons/react";
import { http } from "@/lib/api";

// Global Environmental Catalogue — the seven permanent hubs, live counts.
// Never fabricate counts: tiles show real numbers once loaded, "—" before.

const ICONS = { Flower, Dog, CloudSun, Leaf, Acorn, Drop, Mountains };

export default function GlobalCatalogue() {
  const [hubs, setHubs] = useState(null);

  useEffect(() => {
    let ok = true;
    http.get("/catalogue/hubs")
      .then(({ data }) => { if (ok) setHubs(data.hubs || []); })
      .catch(() => { if (ok) setHubs([]); });
    return () => { ok = false; };
  }, []);

  return (
    <section className="bg-[#0C2D1F] text-[color:var(--np-cream,#F5EBDC)] pb-16 md:pb-24">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="flex items-baseline justify-between mb-8">
          <h2 className="font-mono-tech text-[11px] md:text-xs tracking-[0.35em] uppercase text-[#E5D8C4]/80">
            Global Environmental Catalogue
          </h2>
          <Link to="/explore" data-testid="catalogue-explore-all"
            className="inline-flex items-center gap-1 font-mono-tech text-[10px] tracking-[0.3em] uppercase text-[#E4A15C] hover:underline underline-offset-4">
            Explore all seven hubs <ArrowUpRight size={11} weight="bold" />
          </Link>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 xl:grid-cols-7 gap-4 md:gap-5">
          {(hubs || []).map((h, i) => {
            const Icon = ICONS[h.icon] || Leaf;
            return (
              <motion.div key={h.slug} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }} transition={{ delay: i * 0.06, duration: 0.5 }}>
                <Link
                  to={`/explore/${h.slug}`}
                  data-testid={`catalogue-tile-${h.slug}`}
                  className="block h-full relative border border-[#F5EBDC]/12 p-5 md:p-6 hover:border-[#E4A15C]/70 hover:-translate-y-0.5 transition-all group"
                >
                  <Icon size={34} weight="thin" className="text-[#E4A15C] mb-3 group-hover:scale-110 transition-transform" />
                  <div className="font-serif-display text-xl leading-tight text-[#F5EBDC]">{h.label}</div>
                  <div className="font-mono-tech text-[9px] tracking-[0.24em] uppercase text-[#E5D8C4]/60 mt-1.5">
                    {h.entity_count} pages · {h.observation_count} obs
                  </div>
                </Link>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
